import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type Error as SchemaError } from '../schemas/Error';
import { type Promocode as SchemaPromocode } from '../schemas/Promocode';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @description Возвращает детальную информацию о промокоде по его идентификатору
 * @tags Promocodes
 * @summary Получение детальной информации о промокоде
 */
export const PromocodeGetByIdContentType = '' as const;
export type PromocodeGetByIdRequest = void;
export type PromocodeGetByIdResponses = LinkCommonErrorResponses & {
    /**
     * @description Успешная операция
     */
    '200': {
        'application/json': SchemaPromocode;
    };
    /**
     * @description Not found
     */
    '404': {
        'application/json': SchemaError;
    };
};
export type PromocodeGetByIdResponseSuccess = PromocodeGetByIdResponses['200']['application/json'];
export type PromocodeGetByIdSearchParams = undefined;
export type PromocodeGetByIdPathParameters = {
    id: string;
};
export const PromocodeGetByIdUrl = '/promocodes/{id}' as const;
export const PromocodeGetByIdMethod = 'GET' as const;
export const getPromocodeGetByIdUrl = (params: PromocodeGetByIdPathParameters) =>
    PromocodeGetByIdUrl.replace(/\{(\w+)\}/g, (_match, param: keyof PromocodeGetByIdPathParameters) =>
        String(params[param])
    );
